export enum FilterButtonVariant {
    disabled = "disabled",
    selected = "selected",
    dashed = "dashed",
    default = "default",
}
